import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import React, { useState } from 'react'
import { Axios } from '../../utils/Axios'
import Container from '../../ui/comp/Container'
import TextArea from '../../ui/forms/TextArea'
import Input from '../../ui/forms/Input'
import Button from '../../ui/comp/Button'
import toast from 'react-hot-toast'
import Table from '../../ui/Table/Table'
import Td from '../../ui/Table/Td'
import Tbody from '../../ui/Table/Tbody'
import FormatCurrency from '../../utils/FormatCurrency'
import Thead from '../../ui/Table/Thead'
import { FiEdit } from 'react-icons/fi'
import { CgTrash } from 'react-icons/cg'

function Shipping() {

    const [formData, setFormData] = useState({ area_name: "", cost: 0.00 })
    const queryClient = useQueryClient()

    const { data } = useQuery({
        queryKey: ["shipping"],
        queryFn: async () => {
            const res = await Axios.get('/other/shipping')
            return res.data
        }
    })

    // inputChane

    const inputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }

    // Delete
    const { mutate: deleteMutate } = useMutation({
        mutationFn: async (id) => {
            return Axios.delete('/other/shipping?id=' + id)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["shipping"] })
            toast.success("Deleted")
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete")) {
            deleteMutate(id)
        }
    }


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/other/shipping', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            setFormData({ area_name: "", cost: 0.00 })
            toast.success("Successfully")
            queryClient.invalidateQueries({ queryKey: ["shipping"] })
        }
    })

    const sendData = () => {
        mutate(formData)
    }


    return (
        <div className='w-full relative'>
            <Container title={"Shipping Management"}>
                {/* Head */}
                <div className="w-full space-y-3 mt-5">
                    {/* Names */}
                    <div className="w-full space-y-2">
                        <p className="text-sm">Area Names</p>
                        <TextArea value={formData.area_name} id="area_name" onChange={inputChange} />
                    </div>
                    {/* Cost */}
                    <div className="w-full space-y-2">
                        <p className="text-sm">Shipping Cost</p>
                        <Input type='number' value={formData.cost} id="cost" onChange={inputChange} />
                    </div>
                    {/* Add */}
                    <div>
                        <Button onClick={sendData} loading={isPending}>{formData?.id ? "Update" : "Add "}</Button>
                    </div>
                </div>

                <hr className="my-8" />

                {/* Datas */}
                <div className="w-full">
                    {data && data?.length > 0 && (
                        <div className="w-full">
                            <Table>
                                <Thead>
                                    <tr>
                                        <Td>Destination(s)</Td>
                                        <Td>Shipping Cost(s)</Td>
                                        <Td>Actions</Td>
                                    </tr>
                                </Thead>
                                <Tbody>
                                    {data?.map((area, i) => (
                                        <tr>
                                            <Td>{area?.area_name}</Td>
                                            <Td><FormatCurrency amount={area?.cost} /></Td>
                                            <Td>
                                                <div className="flex items-center gap-3 text-gray-500">
                                                    <button
                                                        onClick={() => {
                                                            setFormData(area)
                                                        }}
                                                        className='text-primary' title='Edit'
                                                    >
                                                        <FiEdit size={18} />
                                                    </button>
                                                    <button onClick={() => handleDelete(area?.id)} title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                                </div>
                                            </Td>
                                        </tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>
                    )}
                </div>
            </Container>
        </div>
    )
}

export default Shipping